import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo7 } from "../../../routes/Module7";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import Card from "../../../components/Card";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo7/Actividad 2.mp3";

const Actividad2 = () => {
  const infoUnidad = modulo7.content[0];
  const infoAct = modulo7.content[0].activities[1];
  const crumbs = [
    {
      title: modulo7.title,
      url: "/" + modulo7.url,
    },
    {
      title:
        modulo7.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo7.content[0].activities[2].name}`,
    linkNext: `${modulo7.url}/${modulo7.content[0].path}/${modulo7.content[0].activities[2].path}`,
    titlePrev: `${modulo7.content[0].activities[0].name}`,
    linkPrev: `${modulo7.url}/${modulo7.content[0].path}/${modulo7.content[0].activities[0].path}`,
  };

  const metadata = {
    color: modulo7.color,
    title: `${modulo7.title} - ${infoAct.name}`,
    name: modulo7.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo7.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-lg-10 col-12 mb-1">
          <ul className="mb-1">
            <li>
              Todos los ciudadanos y ciudadanas del Perú tenemos derechos y
              deberes. Estos derechos y deberes están explicados en la
              Constitución.
            </li>
            <li>
              Escoge uno de los derechos que aparecen a continuación y dibuja en
              un papel una escena relacionada con él.
            </li>
          </ul>
        </div>
        <div className="row">
          <div className="col-lg-5 col-md-6">
            <Card>
              <p className="fs-4 p-4 p-lg-0">
                1. Los peruanos y peruanas tenemos derecho a la tranquilidad y a
                disfrutar de nuestro tiempo libre.
              </p>
            </Card>
          </div>
          <div className="col-lg-5 col-md-6">
            <Card>
              <p className="fs-4 p-4 p-lg-0">
                2. Los peruanos y peruanas tenemos derecho a que nadie entre en
                nuestra casa sin nuestro permiso.
              </p>
            </Card>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Lean los ejemplos de derechos. Compartan ideas
          sobre qué podrían dibujar para cada caso. Destaque cómo los dibujos se
          relacionan con los derechos (ejemplo: niños jugando durante su tiempo
          libre).
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
